import {
  DEFAULT_CRITERION_WEIGHT,
  normalizeCriteriaTarget,
  reorderSectionsByLayout,
  reorderSubcriteriaByLayout,
} from "@/pages/admin/CriteriaPage/components/criteriaGridHelpers";

export const buildScenarioCriteriaDisplayOptions = (templateTarget) => {
  if (!templateTarget) {
    return [];
  }

  const normalized = normalizeCriteriaTarget(templateTarget);
  const sections = reorderSectionsByLayout(
    normalized.sections,
    normalized.sectionsLayout,
  );

  return sections.map((section) => ({
    sectionId: String(section.id),
    label: section.title,
    criteria: reorderSubcriteriaByLayout(
      section.subcriteria,
      section.layout,
    ).map((subcriterion) => ({
      criterionId: String(subcriterion.id),
      label: subcriterion.description,
      weight: subcriterion.weight ?? DEFAULT_CRITERION_WEIGHT,
    })),
  }));
};

export const DEFAULT_EVALUATION_TEMPLATE_NAME = "default";
export const CREATE_OWN_TEMPLATE_OPTION_ID = "__create_own__";

export const findDefaultEvaluationTemplate = (templates = []) =>
  templates.find((item) => item.name === DEFAULT_EVALUATION_TEMPLATE_NAME);

export const buildScenarioTemplateOptions = (templates = [], t) => {
  const defaultTemplate = findDefaultEvaluationTemplate(templates);
  const otherTemplates = templates.filter(
    (item) => item.name !== DEFAULT_EVALUATION_TEMPLATE_NAME,
  );

  return [
    {
      id: CREATE_OWN_TEMPLATE_OPTION_ID,
      value: CREATE_OWN_TEMPLATE_OPTION_ID,
      name: t("input.criteria_create_own"),
      isCreateOwn: true,
      isAction: true,
    },
    ...(defaultTemplate
      ? [
          {
            id: defaultTemplate.id,
            value: String(defaultTemplate.id),
            name: defaultTemplate.name,
          },
        ]
      : []),
    ...otherTemplates.map((item) => ({
      id: item.id,
      value: String(item.id),
      name: item.name,
    })),
  ];
};
